import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 4h6v6h-6v-6","key":"svg-0"}],["path",{"d":"M14 4h6v6h-6v-6","key":"svg-1"}],["path",{"d":"M4 14h6v6h-6v-6","key":"svg-2"}],["path",{"d":"M14 17h6","key":"svg-3"}]]

const IconCategoryMinus = createReactComponent('outline', 'category-minus', 'CategoryMinus', __iconNode);

export default IconCategoryMinus;